import React, { Component } from 'react'; //different
import MainSettingContext from './MainSettingContext';
import './App.css';

class App extends Component {
    static contextType = MainSettingContext;


    onClick = (e) => {
        e.preventDefault()
    }
    render() {
        return (
            <div>
             
            </div>

        );
    }
}
export default App;
